import _regenerator from "@babel/runtime/helpers/esm/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import Vue from 'vue';
import store from '@/store';
import routes from './routes';
import VueRouter from 'vue-router';
import { getQueryVariable } from "@/services/redirecionar";
Vue.use(VueRouter);
var router = new VueRouter({
  routes: routes,
  mode: 'history'
});
router.beforeEach(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(to, from, next) {
    var urlToOpen, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          urlToOpen = getQueryVariable(window.location.search.substring(1), "url");
          if (!urlToOpen) {
            _context.n = 1;
            break;
          }
          window.open(urlToOpen, "_self");
          next(false);
          return _context.a(2);
        case 1:
          if (to.meta.titulo) {
            document.title = to.meta.titulo + ' - MeLembre';
          } else {
            document.title = 'MeLembre';
          }
          if (!(to.meta.precisaAutenticacao && !store.state.auth.autenticado)) {
            _context.n = 7;
            break;
          }
          if (!store.state.auth.token) {
            _context.n = 6;
            break;
          }
          _context.p = 2;
          _context.n = 3;
          return store.dispatch('auth/buscarInformacoes');
        case 3:
          _context.n = 5;
          break;
        case 4:
          _context.p = 4;
          _t = _context.v;
          return _context.a(2, next({
            name: 'Login',
            query: {
              "continue": to.fullPath
            }
          }));
        case 5:
          if (!store.state.auth.autenticado) {
            _context.n = 6;
            break;
          }
          return _context.a(2, next());
        case 6:
          return _context.a(2, next({
            name: 'Login',
            query: {
              "continue": to.fullPath
            }
          }));
        case 7:
          next();
        case 8:
          return _context.a(2);
      }
    }, _callee, null, [[2, 4]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
export default router;